export default __webpack_public_path__ + "static/media/spicy.1926fcdb.jpg";